import { render, staticRenderFns } from "./PreFaturaDespesa.vue?vue&type=template&id=ce1d5776"
import script from "./PreFaturaDespesa.vue?vue&type=script&lang=js"
export * from "./PreFaturaDespesa.vue?vue&type=script&lang=js"
import style0 from "./PreFaturaDespesa.vue?vue&type=style&index=0&id=ce1d5776&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports